// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1ZcDe","requiredAsterisk":"Info_requiredAsterisk__37sAy"};